import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('whats_included'),
    description: defineMessage('bulletrequirements_and__ustomised_to_your_needs_1'),
    contactUs: defineMessage('contact_us'),
};
